/* eslint-disable @typescript-eslint/consistent-type-assertions */
import * as React from 'react';

import { Context } from './context';

export type ProvideProps<BannerComponentProps> = {
  Component: React.ComponentType<BannerComponentProps>;
  defaultProps: BannerComponentProps;
  children: React.ReactNode;
};

export const BannerProvider = <BannerComponentProps,>({
  Component,
  defaultProps,
  children,
}: ProvideProps<BannerComponentProps>): JSX.Element => {
  const [props, setProps] = React.useState<BannerComponentProps>({
    ...defaultProps,
  });
  const [show, setShow] = React.useState(false);

  const hideBanner = React.useCallback(() => setShow(false), []);
  const showBanner = React.useCallback(
    (passedProps: unknown) => {
      setProps({ ...props, ...(passedProps as Partial<BannerComponentProps>) });
      setShow(true);
    },
    [props]
  );

  return (
    <Context.Provider value={{ showBanner, hideBanner }}>
      {children}
      <Component
        data-qa="banner"
        data-testid="banner"
        handleOnClose={hideBanner}
        show={show}
        {...props}
      />
    </Context.Provider>
  );
};
